import React, { Component, Fragment } from "react";
import { renderToStaticMarkup } from "react-dom/server";

import { toPersianNumber } from "../../../classes/utils";
import withRouter from "../../withRouter/withRouter";

import PrintOrders from "../PrintOrders/PrintOrders2";
import "../Orders.css";

class Order extends Component {
    state = {
        order: null,
    };
    constructor(props) {
        super(props);
        this.printOrder = this.printOrder.bind(this);
        this.update_order_status = this.update_order_status.bind(this);
    }

    componentDidMount() {
        this.request_data();
    }

    componentDidUpdate(prevProps, prevState) {}

    request_data() {
        let { toast, connection, router } = this.props;
        connection
            .get_filtered_data("orders", { id: router.params.id })
            .then((res) => {
                let order = res.data.orders[0];
                this.setState({ order });
            })
            .catch((err) => {
                toast("خطا در دریافت سفارش", " خطای : " + err, " danger");
            });
    }

    printOrder(order) {
        const _window = <PrintOrders orders={[order]} />;
        var prinTab = window.open();
        prinTab.document.write(renderToStaticMarkup(_window));
        prinTab.document.close();
        prinTab.print();
    }

    update_order_status(order, tracking_Code) {
        let { connection, toast } = this.props;

        connection
            .update_order_status(order, tracking_Code)
            .then((res) => {
                toast(
                    "بروز رسانی سفارش",
                    "سفارش با موفقیت بروزرسانی شد",
                    " confirm"
                );
                let newOrder = res.data;
                let { ordersToShow: orders } = this.state;
                let index = orders.findIndex((o) => {
                    return o.id == newOrder.id;
                });
                orders[index] = newOrder;

                this.setState({ ordersToShow: orders });
            })
            .catch((err) => {
                toast(
                    "خطا در ارسال اطلاعات",
                    "بروزرسانی سفارش با خطا مواجه شد.",
                    " danger"
                );
            });
    }

    render() {
        let { order } = this.state;

        let tracking_code = "";
        return (
            <div className="OrdersComponentContainer">
                <div className="ordersWraper">
                    {order && (
                        <div
                            className={"orderRow " + order.status}
                            key={order.id}
                        >
                            <div className="top">
                                <div className="costumerDetail">
                                    <div className="id">{order.id}</div>
                                    <div className="costumerName">
                                        <a className="text primary">
                                            {order.name}
                                        </a>
                                    </div>
                                    <div className="costumerMobile text info">
                                        {order.costumerMobile}
                                    </div>
                                    <div className="costumerAddress">
                                        {order.address}
                                    </div>
                                    <div className="costumerPostalCode">
                                        {toPersianNumber(order.zip)}
                                    </div>
                                    <div className="postMethod">
                                        {order.shipping === "post"
                                            ? "پست"
                                            : order.shipping === "tipax"
                                            ? "تیپاکس"
                                            : order.shipping === "freight"
                                            ? "پست پس کرایه"
                                            : " نوع ارسال نا مشخص ؟"}
                                    </div>
                                    <div className="note">{order.comment}</div>
                                </div>
                                <div className="items">
                                    {order.items.map((i, itemIndex) => {
                                        return (
                                            <div
                                                className="itemRow"
                                                key={itemIndex}
                                            >
                                                <div className="name ">
                                                    <a
                                                        className=" text secondary"
                                                        href={"/items/" + i.id}
                                                    >
                                                        {i.name}
                                                    </a>
                                                </div>
                                                <div className="amount text info">
                                                    {toPersianNumber(
                                                        i.amount,
                                                        true
                                                    )}
                                                    {i.unit}
                                                </div>
                                                <div className="total text primary">
                                                    {toPersianNumber(
                                                        order.check[itemIndex]
                                                            .price,
                                                        true
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}

                                    <div className="totalOrderCost text primary">
                                        <div className="text info">
                                            قیمت کل اجناس
                                        </div>

                                        <div></div>
                                        {order.totalItemsPrice
                                            ? toPersianNumber(
                                                  order.totalItemsPrice,
                                                  true
                                              )
                                            : "not provided"}
                                    </div>
                                    <div className="postalCost text primary">
                                        <div className="text info">
                                            هزینه پست
                                        </div>

                                        <div></div>
                                        {order.shipping_cost
                                            ? toPersianNumber(
                                                  order.shipping_cost,
                                                  true
                                              )
                                            : "not provided"}
                                    </div>
                                    <div className="packingCost text primary">
                                        <div className="text info">
                                            هزینه بسته بندی
                                        </div>

                                        <div></div>
                                        {order.packingPrice
                                            ? toPersianNumber(
                                                  order.packingPrice,
                                                  true
                                              )
                                            : "not provided"}
                                    </div>
                                    <div className="totalPrice text primary">
                                        <div className="text info">قیمت کل</div>

                                        <div></div>
                                        {order.total
                                            ? toPersianNumber(order.total, true)
                                            : "not provided"}
                                    </div>
                                </div>
                                <div className="actions">
                                    <div className="status">{order.status}</div>
                                    <div className="totalPrice text primary">
                                        {order.total
                                            ? toPersianNumber(order.total, true)
                                            : "not provided"}
                                    </div>
                                    <div className="note">{order.note}</div>

                                    <button
                                        onClick={(e) => this.printOrder(order)}
                                        className="btn info"
                                    >
                                        چاپ
                                    </button>
                                    {(order.status == "pending" ||
                                        order.status == "sent") && (
                                        <div className="sent">
                                            <input
                                                type="text"
                                                placeholder=" کد رهگیری پستی"
                                                defaultValue={
                                                    order.tracking_code
                                                }
                                                onChange={(ev) =>
                                                    (tracking_code =
                                                        ev.target.value)
                                                }
                                            />
                                            <button
                                                onClick={(ev) =>
                                                    this.update_order_status(
                                                        order.id,
                                                        tracking_code
                                                    )
                                                }
                                                className="sent btn confirm"
                                            >
                                                {order.status == "sent"
                                                    ? order.tracking_code
                                                        ? "تغیر کد رهگیری"
                                                        : "ثبت کد رهگیری"
                                                    : "سفارش ارسال شد"}
                                            </button>
                                        </div>
                                    )}
                                    {order.status == "sent" &&
                                        order.tracking_code && (
                                            <div className="postalTackCode">
                                                کد رهگیری
                                                {order.tracking_code}
                                            </div>
                                        )}

                                    {order.time && (
                                        <div className="orderTime">
                                            {new Date(
                                                order.time
                                            ).toLocaleString("fa-IR")}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="bottom">
                                <div className="payment">
                                    <div className="method text primary">
                                        <div className="name text info">
                                            نوع پرداخت :{" "}
                                        </div>
                                        <div className="value text primary">
                                            {order.payment === "offline" &&
                                                "آفلاین"}
                                            {order.payment === "online" &&
                                                "آنلاین"}
                                        </div>
                                    </div>
                                    {order.payment === "offline" &&
                                        (order.status === "pending" ||
                                            order.status === "sent") && (
                                            <div className="info offline">
                                                {order.payment_info &&
                                                    order.payment_info
                                                        .entries && (
                                                        <table className="entry">
                                                            <thead>
                                                                <td>روش</td>
                                                                <td>مقدار</td>
                                                                <td>رهگیری</td>
                                                                <td>به نام</td>
                                                                <td>توضیحات</td>
                                                            </thead>
                                                            <tbody>
                                                                {order.payment_info.entries.map(
                                                                    (
                                                                        entry,
                                                                        index
                                                                    ) => {
                                                                        console.log(
                                                                            entry
                                                                        );
                                                                        return (
                                                                            <tr
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                <td className="method">
                                                                                    {entry.method ===
                                                                                        "card" &&
                                                                                        "کارت به کارت"}
                                                                                    {entry.method ===
                                                                                        "paya" &&
                                                                                        "پایا"}
                                                                                    {entry.method ===
                                                                                        "account" &&
                                                                                        "حساب به حساب"}
                                                                                </td>
                                                                                <td className="amount">
                                                                                    {toPersianNumber(
                                                                                        entry.amount ||
                                                                                            "",
                                                                                        true
                                                                                    )}
                                                                                </td>
                                                                                <td className="tracking">
                                                                                    {
                                                                                        entry.tracking
                                                                                    }
                                                                                </td>
                                                                                <td className="name">
                                                                                    {
                                                                                        entry.name
                                                                                    }
                                                                                </td>
                                                                                <td className="comment">
                                                                                    {
                                                                                        entry.comment
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    }
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    )}
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Order);
